import { Flex, Text } from '@vtex/admin-ui'
import { useIntl } from 'react-intl'
import { FieldGroupBox, RuleStack, useDrawerState } from 'ui'
import {
  BuyTogetherBenefit,
  BuyTogetherEffect,
} from '../../../../../../typings'
import { ItemsView } from '../../../../../ItemsView'
import { DiscountRule } from '../../DiscountRule'
import styles from '../../styles'
import { BuyTogetherBenefitEditor } from '../Editor'
import { messages } from '../messages'
import { EmptyBenefit } from './Empty'

type BuyTogetherBenefitViewProps = {
  config: BuyTogetherEffect | undefined
  onChange: (config: BuyTogetherBenefit | undefined) => void
  name: string
}

export function BuyTogetherBenefitView(props: BuyTogetherBenefitViewProps) {
  const { config, onChange, name } = props
  const { $t } = useIntl()

  const drawerState = useDrawerState()

  const handleRemove = () => onChange(undefined)

  const benefitConfig = config?.benefit

  return (
    <div>
      {benefitConfig ? (
        <Flex direction="column" className={styles.view.content}>
          <Text variant="action1">{$t(messages.title, { index: 2 })}</Text>
          <FieldGroupBox name={name} withBorder={false}>
            <RuleStack>
              <ItemsView
                config={benefitConfig}
                onEdit={drawerState.show}
                onRemove={handleRemove}
              />
              <DiscountRule
                discount={benefitConfig.discount}
                onEdit={drawerState.show}
                onRemove={handleRemove}
              />
            </RuleStack>
          </FieldGroupBox>
        </Flex>
      ) : (
        <EmptyBenefit onAdd={drawerState.show} name={name} />
      )}

      <BuyTogetherBenefitEditor
        state={drawerState}
        initialConfig={config?.benefit}
        onSave={(newSettings) => onChange(newSettings)}
        trigger={config?.trigger}
      />
    </div>
  )
}
